import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';

import type { IAppRegion } from '~/lib/appSettings';
import type {
  IApiSignUpRequestBody,
  IApiSignUpResponseBody,
} from '../AuthApi.types';
import { useApi } from '~/lib/api';
import { generateSessionId, useAuth } from '~/lib/auth';

export type IUseSignUpMutationValues = {
  region: IAppRegion;
  body: IApiSignUpRequestBody;
};

export const useSignUpMutation = (): UseMutationResult<
  IApiSignUpResponseBody,
  unknown,
  IUseSignUpMutationValues
> => {
  const api = useApi();
  const auth = useAuth();

  return useMutation({
    mutationFn: (values: IUseSignUpMutationValues) =>
      api.auth.signUp(values.region, values.body),
    onSuccess: async (data, values) => {
      const sessionId = generateSessionId(values.region, data.user._id);
      await auth.setAuthorization({
        sessionId,
        region: values.region,
        user: data.user,
        authToken: data.authToken,
      });
    },
  });
};
